import React from "react";
import { Typography, CircularProgress, Box } from "@mui/material";
import { colors } from "../../theme/theme";

const HealthCheck = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      flexDirection="column"
    >
      <Typography  sx={{
                        fontFamily: '"Inter", sans-serif',
                        fontSize: '16px',
                        fontWeight: 700,
                        color: colors.primary,
                      }} variant="h6" gutterBottom>
       Hey, Welcome to Procurement Systems
      </Typography>
      {/* <CircularProgress /> */}
    </Box>
  );
};

export default HealthCheck;